const NAMESPACE = 'SEARCH_RESULTS';

const SET_SEARCH_RESULTS = `${NAMESPACE}/SET_SEARCH_RESULTS`;
const CLEAR_SEARCH_RESULTS = `${NAMESPACE}/CLEAR_SEARCH_RESULTS`;

export {
    CLEAR_SEARCH_RESULTS,
    SET_SEARCH_RESULTS,
};

export default NAMESPACE;
